<template>

	<div>
		<ul>
			<li>
				<h2 class="header_h2">商品管理</h2>
			</li>
			<li class="limargin">
				<el-button style="margin-left:10px;" @click="baonewAdd">新增</el-button>
				<el-input v-model="select_word" placeholder="名称查找" style="display:inline-block;width:150px;"></el-input>
			</li>
		</ul>
		<el-tabs v-model="curgoods_typeid" @tab-click="tabhandleClick">
			<el-tab-pane v-for="gtype in goodstypelist" :label="gtype.typename" :name="gtype.id" :key="gtype.typename">
				<el-table border ref="multipleTable" tooltip-effect="dark" :data="getgoods(gtype.id).slice((currentPage-1)*pagesize,currentPage*pagesize)">
					<el-table-column prop="goods_status" label="是否启用">
						<template slot-scope="scope">
							<label v-if="scope.row.goods_status=='1'">是</label>
							<label v-if="scope.row.goods_status=='0'">否</label>
						</template>
					</el-table-column>
					<el-table-column prop="ordernum" label="排序号"></el-table-column>
					<el-table-column prop="goods_address" label="logo" width="120px">
						<template slot-scope="scope5">
							<div>
								<img style="max-width:100px ; width:auto ;height: auto;" :src='"/img"+ scope5.row.goods_address' alt="">
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="goods_name" label="商品名称" width="160px"></el-table-column>
					<el-table-column prop="adaptsex" label="适用性别">
						<template slot-scope="scope">
							<div v-for="item in AdaptSex">
								<label v-if='scope.row.adaptsex==item.value'>{{item.key}}</label>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="goods_orgprice" label="原价"></el-table-column>
					<el-table-column prop="goods_saleprice" label="售价"></el-table-column>
					<el-table-column prop="usable_date" label="起始有效期"></el-table-column>
					<el-table-column prop="unusable_date" label="结束有效期"></el-table-column>
					<el-table-column prop="goods_stock" label="库存量"></el-table-column>
					<el-table-column prop="goods_salenum" label="售出量"></el-table-column>
					<el-table-column prop="goods_detail" label="商品描述"></el-table-column>
					<el-table-column label="操作" width="200px">
						<template slot-scope="scope" fixed="right">
							<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>

							<el-button @click="togoodsitem(scope.row)" icon="el-icon-edit" type="text" size="small">设置项目</el-button>
						</template>
					</el-table-column>
					<el-table-column label="上传logo" width="200px">
						<template slot-scope="scope" fixed="right">
							<a href="javascript:;" class="uploadfile">上传图片
								<input type="file" name="" id="" @change="getFile($event, scope.row)" accept=".jpg,.png,.bmp,.gif">
							</a>
						</template>
					</el-table-column>
				</el-table>
				<el-footer style="margin-top:20px;">
					<template>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
							 :page-sizes="[10, 20, 40,80]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="getgoods(gtype.id).length"></el-pagination>
						</div>
					</template>
				</el-footer>
			</el-tab-pane>
		</el-tabs>

		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form style="width: 100%;" :model="EditInfo" ref="EditInfo">
				<el-form-item label="启用">
					<el-switch v-model="EditInfo.goods_status" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input v-model="EditInfo.goods_name"></el-input>
				</el-form-item>
				<el-form-item label="适用性别">
					<el-select style=" width: 80px;  height:30px;" v-model="EditInfo.adaptsex">
						<el-option v-for="item in AdaptSex" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="原价">
					<el-input type='number' size="medium" v-model.trim="EditInfo.goods_orgprice"></el-input>
				</el-form-item>
				<el-form-item label="售价">
					<el-input type='number' size="medium" v-model.trim="EditInfo.goods_saleprice"></el-input>
				</el-form-item>
				<el-form-item label="有效期">
					<el-input type='date' v-model="EditInfo.usable_date"></el-input>
				</el-form-item>
				<el-form-item label="到">
					<el-input type='date' v-model="EditInfo.unusable_date"></el-input>
				</el-form-item>
				<el-form-item label="库存量">
					<el-input type='number' size="medium" v-model.trim="EditInfo.goods_stock"></el-input>
				</el-form-item>
				<el-form-item label="售出量">
					<el-input type='number' size="medium" v-model.trim="EditInfo.goods_salenum"></el-input>
				</el-form-item>
				<el-form-item label="商品描述">
					<el-input v-model="EditInfo.goods_detail"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd" v-dialogDrag>
			<el-form :model="AddInfo" ref="AddInfo">
				<el-form-item label="启用">
					<el-switch v-model="AddInfo.goods_status" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input v-model="AddInfo.goods_name"></el-input>
				</el-form-item>
				<el-form-item label="适用性别">
					<el-select style=" width: 80px;  height:30px;" v-model="AddInfo.adaptsex">
						<el-option v-for="item in AdaptSex" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="原价">
					<el-input type='number' size="medium" v-model.trim="AddInfo.goods_orgprice"></el-input>
				</el-form-item>
				<el-form-item label="售价">
					<el-input type='number' size="medium" v-model.trim="AddInfo.goods_saleprice"></el-input>
				</el-form-item>
				<el-form-item label="有效期">
					<el-input type='date' v-model="AddInfo.usable_date"></el-input>
				</el-form-item>
				<el-form-item label="到">
					<el-input type='date' v-model="AddInfo.unusable_date"></el-input>
				</el-form-item>
				<el-form-item label="库存量">
					<el-input type='number' size="medium" v-model.trim="AddInfo.goods_stock"></el-input>
				</el-form-item>
				<el-form-item label="售出量">
					<el-input type='number' size="medium" v-model.trim="AddInfo.goods_salenum"></el-input>
				</el-form-item>
				<el-form-item label="商品描述">
					<el-input v-model="AddInfo.goods_detail"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>



	</div>
</template>

<script>
	import goods from '../../apifunction/Goods.js'
	export default {
		created() {
			this.userent = this.$myglobal.getUserInfo();
			this.initData()
		},
		data() {
			return {
				AdaptSex: this.$enums.AdaptSex,
				userent: null,
				goodstypelist: [],
				goodslist: [],
				currentPage: 1,
				pagesize: 10,
				curgoods_typeid: '',
				bao1edit: false,
				bao1newadd: false,
				select_word: "",
				idx: null,
				EditInfo: {
					goods_id: '',
					corpid: '',
					goods_name: '',
					adaptsex: '3',
					goods_typeid: '',
					goods_type: '',
					goods_detail: '',
					goods_orgprice: '',
					goods_saleprice: '',
					goods_status: '1',
					create_date: '',
					create_user: '',
					operate_date: '',
					operate_user: '',
					citys: '',
					goods_address: '',
					usable_date: '',
					unusable_date: '',
					goods_stock: '10',
					goods_salenum: '0',
					ordernum: '1'
				},
				AddInfo: {
					goods_id: '',
					corpid: '',
					goods_name: '',
					adaptsex: '3',
					goods_typeid: '',
					goods_type: '',
					goods_detail: '',
					goods_orgprice: '',
					goods_saleprice: '',
					goods_status: '1',
					create_date: '',
					create_user: '',
					operate_date: '',
					operate_user: '',
					citys: '',
					goods_address: '',
					usable_date: '',
					unusable_date: '',
					goods_stock: '10',
					goods_salenum: '0',
					ordernum: '1'
				}

			}
		},
		watch: {
			"$route": "initData"
		},
		computed: {

			data() {
				return this.goodslist.filter(item => {

					if (item.goods_name.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		},
		methods: {
			togoodsitem(row) {
				var data = {
					path: '/goodsitem',
					query: {
						ent: JSON.stringify(row)
					}
				};
				this.$router.push(data)
			},
			formatdate(d) {
				return this.$moment(d).format("YYYY-MM-DD");
			},
			initData() {

				goods.GetGoodsByCorpid(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.goodslist = JSON.parse(ent.Data);
							} else
								this.goodslist = [];

							//this.getgoods(this.curgoods_typeid );
						} else
							this.$message.info(ent.Msg);
						this.GetAllGoodsType();
					});

			},
			GetAllGoodsType() {
				goods.GetGoodsTypeByCorpid(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.goodstypelist = JSON.parse(ent.Data);
								this.curgoods_typeid = this.goodstypelist[0].goods_typeid;
								}else
								this.goodstypelist = [];

						} else
							this.$message.info(ent.Msg);
					})
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			getgoods(goods_typeid) {
				if (this.goodslist.length < 1)
					return [];
				return this.goodslist.filter(f => {
					if (f.goods_typeid == goods_typeid) {
						return f;
					}
				})
			},
			tabhandleClick() {
				this.pagesize = 10;
				this.currentPage = 1;
			},
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					goods_id: row.goods_id,
					corpid: row.corpid,
					goods_name: row.goods_name,
					adaptsex: row.adaptsex,
					goods_typeid: row.goods_typeid,
					goods_type: row.goods_type,
					goods_detail: row.goods_detail,
					goods_orgprice: row.goods_orgprice,
					goods_saleprice: row.goods_saleprice,
					goods_status: row.goods_status,
					create_date: row.create_date,
					create_user: row.create_user,
					operate_date:this.formatdate(row.operate_date),
					operate_user: row.operate_user,
					citys: row.citys,
					goods_address: row.goods_address,
					usable_date:this.formatdate(row.usable_date),
					unusable_date:this.formatdate(row.unusable_date),
					goods_stock: row.goods_stock,
					goods_salenum: row.goods_salenum,
					ordernum: row.ordernum
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				if (this.EditInfo.goods_name == '') {
					this.$message.success("名称不能为空！");
					return;
				}
				goods.EditGoods(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.goodslist.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo = {
					goods_id: this.CommonFun.NewGuid(),
					corpid: this.userent.corpid,
					goods_name: '',
					adaptsex: '3',
					goods_typeid: this.curgoods_typeid,
					goods_type: '',
					goods_detail: '',
					goods_orgprice: '0',
					goods_saleprice: '0',
					goods_status: '1',
					create_date: this.CommonFun.GetNowDateTime(),
					create_user: this.userent.id,
					operate_date: this.CommonFun.GetNowDateTime(),
					operate_user: this.userent.id,
					citys: '',
					goods_address: '',
					usable_date: this.CommonFun.GetNowDate(),
					unusable_date: this.CommonFun.GetNowDate(),
					goods_stock: '10',
					goods_salenum: '0',
					ordernum: '1'
				}
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.goods_name == '') {
					this.$message.success("名称不能为空！");
					return;
				}
				let gty = this.goodstypelist.find(f => f.id == this.curgoods_typeid);
				// alert(JSON.stringify(gty))
				this.AddInfo.goods_type = gty.typename;
				goods.AddGoods(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.goodslist.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
			getFile(event, row) {
				//alert(JSON.stringify(event.target.files))
				var file = event.target.files;

				// 上传类型判断
				var imgName = file[0].name;
				var idx = imgName.lastIndexOf(".");
				if (idx != -1) {
					var ext = imgName.substr(idx + 1).toUpperCase();
					ext = ext.toLowerCase();
					if (ext != 'jpg' && ext != 'png' && ext != 'bmp' && ext != 'gif') {
						alert('图片格式不支持！')
					} else {

						let param = new FormData(); //创建form对象
						param.append('file', file[0]); //通过append向form对象添加数据
						//param.append('branch_id', row.branch_id);
						goods.UploadGoodsImg(param, row.goods_id)
							.then(res => {
								let ent = JSON.parse(JSON.stringify(res.data))
								if (ent.Flag == 'success') {
									row.goods_address = ent.Data;
									this.$message.info('上传成功!');

								} else
									this.$message.info(ent.Msg);
							})
					}
				} else {

				}
			},
		}
	}
</script>

<style>
</style>
